import React, { FC } from "react";
import { TagStyled, Wrapper } from "./elements";

type Props = {
  color: string;
  text: string;
  isHoverable?: boolean;
};

const Tag: FC<Props> = props => {
  const { color, text, isHoverable } = props;

  return (
    <Wrapper>
      <TagStyled $isHoverable={isHoverable} color={color}>
        {text}
      </TagStyled>
    </Wrapper>
  );
};

export default Tag;
